export const NUMBER_OF_REVIEWS_REQUESTED = 12;
export const NUMBER_OF_CARDS_DESKTOP = 3;
export const NUMBER_OF_CARDS_TABLET = 2;
